import styled from 'styled-components'
import { Text } from '@usap/uicomponents'

export const QuestionText = styled(Text)`
  color: rgb(51, 51, 51);
  font-size: 14px;
  font-weight: bold;
  width: 306px;
  letter-spacing: 0;
  line-height: 20px;
  @media (max-width: 1024px) {
    margin-left: 5px
  }
`

export const AnswerText = styled(Text)`
  color: rgb(51, 51, 51);
  font-size: 14px;
  font-weight: normal;
  font-style: italic;
  letter-spacing: 0;
  overflow-wrap: break-word;
  line-height: 20px;
  width: 306px;
  @media (max-width: 1024px) {
    margin-left: 5px
  }
  > a {
    overflow-wrap: break-word;
  }
`

export const BestAnswer = styled.span`
  color: rgb(46, 71, 135);
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
  margin-right: 4px;
  font-style: normal;
`

export const SeeMore = styled(Text)`
  color: rgb(46, 107, 158);
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
  letter-spacing: 0;
  line-height: 20px;
  font-style: normal;
`
